// extracted by mini-css-extract-plugin
export default {"layout":"Layout_layout__j-ubU","layout__home-icon":"Layout_layout__home-icon__YaMtg"};